
import GoodsListPage from '@/components/GoodsListPage/index-new.vue'

export default {
	name: 'TradeList',
	components: {
		GoodsListPage
	},
	data() {
		return {
			loading: true,
			month: new Date().getMonth() + 1,
			goodsData: [],
			pageInfo: {
				page: 1,
				pageSize: 10,
				total: 0
			}
		}
	},
	mounted() {
		this.getTradesList()
	},
	methods: {
		// 获取游戏交易榜数据
		async getTradesList() {
			const par = {
				action: {},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			const res = await this.$api.monthsTradesPageAPI(par)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			if (res.data) {
				const data = res.data
				this.goodsData = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
			}
			this.loading = false
		},
		handleCurrentChange(v) {
			this.pageInfo.page = v
			this.getTradesList()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.pageSize = pageSize
			this.pageInfo.page = 1
			this.getTradesList()
		}
	}
}
